import lazyLoad from "../utils/lazy";

const cGifts = () => {
  function runSlide() {
    const container = document.querySelector('.gifts__slider')
    const sliders = container?.querySelectorAll('.gifts__slide')

    if (sliders?.length) {
      sliders.forEach((el) => {
        if (window.innerWidth <= 1024) {
          el.classList.add('swiper-slide')
        } else {
          el.classList.remove('swiper-slide')
        }
      })
    }
  }

  runSlide()

  window.addEventListener('resize', function(event) {
    runSlide()
  }, true);

  const slider = new Swiper('.gifts__slider', {
    slidesPerView: "auto",
    spaceBetween: 24,
    navigation: {
      nextEl: ".gifts .slide-navigation__button_next",
      prevEl: ".gifts .slide-navigation__button_prev",
    },
    pagination: {
      el: ".slide-pagination",
      clickable: true,
      dynamicBullets: true,
    },
  })
  
  slider.on('slideChange, init', function () {
    lazyLoad()
  });
}

export default cGifts
